import "babel-polyfill";
require("es6-promise").polyfill();

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import "./assets/css/index.scss"

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount("#app")
